import { render, staticRenderFns } from "./CopyToSelect.vue?vue&type=template&id=ba101712"
import script from "./CopyToSelect.vue?vue&type=script&lang=js"
export * from "./CopyToSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports